module.exports = __webpack_public_path__ + "static/media/round15.48d9a7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round15.png
// module id = 1166
// module chunks = 0